<app-header></app-header>

<div class="page-title-area page-title-style-two item-rights">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Legislatie Cadre Medicale</li>
            </ul>
            <h2>Legislatie Cadre Medicale</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h3>Asistente</h3>
                <ul>
                    <li>
                        <a
                        href="../../../assets/img/pdf/OUG 144 din 2008.pdf"
                        download
                    >Ordonanta de urgenta Nr. 144/2008 din 28 octombrie 2008</a>

                    </li>
                    <li>
                        <a
                            href="../../../assets/img/pdf/Lege 46 din 2003.pdf"
                            download
                        >Lege Nr. 46/2003 din 21 ianuarie 2003</a>
                    </li>
                    <li>
                        <a
                        href="../../../assets/img/pdf/Ord. 1101 din 2016.pdf"
                        download
                    >Ordin Nr. 1101/2016 din 30 septembrie 2016</a>
                    </li>
                    <li>
                        <a
                            href="../../../assets/img/pdf/Ord. 1410 din 2016.pdf"
                            download
                        >Ordin Nr. 1410/2016 din 12 decembrie 2016</a>
                    </li>
                    <li>
                        <a
                            href="../../../assets/img/pdf/Ord. 1761 din 2021.pdf"
                            download
                        >Ordin Nr. 1761/2021 din 3 septembrie 2021</a>
                    </li>
                    <li>
                        <a
                            href="../../../assets/img/pdf/art. 64.pdf"
                            download
                        >Articolul 64</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
